import axios from "axios";

import { authEndpoint } from "Constants/Auth";

export const encrypt = async (user) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const body = {
      data: user.access_token,
    };

    const { data } = await axios.post(`${authEndpoint}/encryption/onboarding/encrypt`, body, config);

    return data;
  } catch (err) {
    console.log('error in onboarding/encrypt thunk =>', err);
  }
}
